// The page a patient opens from the WhatsApp link. Authenticated only by
// the token in the URL, so it is open to anyone and lives outside the
// app shell (no navbar, no login).
const routes = [
  {
    path: "/p/:token",
    name: "patient_round",
    meta: { role: ["anyone"] },
    component: () =>
      import(/* webpackChunkName: 'patient' */ "views/Patient/Round.vue"),
  },
];

export default routes;
